// extracted by mini-css-extract-plugin
module.exports = {"root":"root___2iZkx","loading":"loading___9z0zm"};